import { render, staticRenderFns } from "./BuyCoinsDefault.vue?vue&type=template&id=4a7ff157&scoped=true&"
import script from "./BuyCoinsDefault.vue?vue&type=script&lang=ts&"
export * from "./BuyCoinsDefault.vue?vue&type=script&lang=ts&"
import style0 from "./BuyCoinsDefault.vue?vue&type=style&index=0&id=4a7ff157&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a7ff157",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
